var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"fa fa-circle",class:{
		'has-transition':_vm.hasTransition,
		online: _vm.userIsOnline
	},attrs:{"title":_vm.title}})
}
var staticRenderFns = []

export { render, staticRenderFns }